<template>
  <div class="publicTransferAudit">
    <el-dialog
      title="对公转账审核"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="640px"
      :before-close="handleClose"
    >
      <el-form
        ref="formInline"
        :model="formInline"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="班级名称">
          {{ formInline.skuName }}
        </el-form-item>
        <el-form-item label="支付金额">
          {{ formInline.payAmt }}
        </el-form-item>
        <el-form-item label="订单编号">
          {{ formInline.orderNumber }}
        </el-form-item>
        <el-form-item label="转账人">
          {{ formInline.remitterName }}
        </el-form-item>
        <el-form-item label="收款商户名称">
          {{ formInline.gatheringName }}
        </el-form-item>
        <el-form-item label="收款账号">
          {{ formInline.gatheringNumber }}
        </el-form-item>
        <el-form-item label="支付凭证">
          <div class="flx">
            <div class="flx_inner" v-for="(item, index) in formInline.remitterVoucher" :key="index">
              <el-image
                style="width: 80px; height: 80px"
                :src="item"
                :preview-src-list="[item]"
              >
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="审核状态" prop="auditStatus">
          <el-radio-group
            v-model="formInline.auditStatus"
            @change="changeAuditStatus"
          >
            <el-radio label="2">通过</el-radio>
            <el-radio label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见" prop="auditNote">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="100"
            show-word-limit
            v-model="formInline.auditNote"
            placeholder="请填写审核意见"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="formInline.auditStatus === '2'"
          label="支付时间"
          prop="payTimeStr"
        >
          <el-date-picker
            v-model="formInline.payTimeStr"
            type="datetime"
            @change="payTimeStrChange"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAuditInfoByOrderId,
  auditRemitOrder,
} from "@/api/orderAdmin/orderList";
import { getPrivateImgUrl } from '@/api/product/base'
export default {
  data() {
    return {
      dialogVisible: false,
      formInline: {
        skuName: "",
        payAmt: "",
        orderNumber: "",
        remitterName: "",
        gatheringName: "",
        gatheringNumber: "",
        remitterVoucher: [],
        auditStatus: "",
        auditNote: "",
        payTimeStr: "",
      },
      rules: {
        auditStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        payTimeStr: [
          { required: false, message: "请选择日期", trigger: "change" },
        ],
        auditNote: [
          { required: false, message: "请填写审核意见", trigger: "blur" },
        ],
      },
      orderId: "",
    };
  },
  methods: {
    payTimeStrChange(payload) {
      this.formInline.payTimeStr = payload;
    },
    // 初始化
    async init(payload) {
      this.orderId = payload.id;
      const res = await getAuditInfoByOrderId({ orderId: payload.id });
      this.formInline = {
        skuName: payload.skuName || "",
        payAmt: payload.payAmt || "",
        orderNumber: res.data?.orderNumber || "",
        remitterName: res.data?.remitterName || "",
        gatheringName: res.data?.gatheringName || "",
        gatheringNumber: res.data?.gatheringNumber || "",
        remitterVoucher: [],
      };
      const list = res.data?.remitterVoucher?.split(",") || []
      list.filter(item => {
        getPrivateImgUrl(item).then(res => {
          this.formInline.remitterVoucher.push(res.data)
        })
      })
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          let params = {
            orderId: this.orderId,
            auditStatus: this.formInline.auditStatus,
            auditNote: this.formInline.auditNote,
            payTimeStr: this.formInline.payTimeStr,
          };

          if (params.auditStatus === "3") delete params.payTimeStr;
          auditRemitOrder({ ...params }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                message: "审核成功",
                type: "success",
              });
              this.dialogVisible = false;
            }
          });
        }
      });
    },
    // 通过、驳回
    changeAuditStatus(payload) {
      if (payload === "2") {
        this.$set(this.rules, "payTimeStr", {
          required: true,
          message: "请选择日期",
          trigger: "change",
        });
        this.$set(this.rules, "auditNote", {
          required: false,
          message: "请填写审核意见",
          trigger: "blur",
        });
      } else if (payload === "3") {
        this.$set(this.rules, "payTimeStr", {
          required: false,
          message: "请选择日期",
          trigger: "change",
        });
        this.$set(this.rules, "auditNote", {
          required: true,
          message: "请填写审核意见",
          trigger: "blur",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.publicTransferAudit {
  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 20px 30px;
  }
  .flx{
    display: flex;
    flex-wrap: wrap;
    .flx_inner{
      margin: 0 6px;
    }
  }
}
</style>